import { ref, onMounted } from 'vue';
import { apiFreeCompany } from '@/request/api';

export default () => {
    const companyInfo = ref({})

    // 按域名获取公司信息
    async function getCompanyInfo() {
        const { data } = await apiFreeCompany({ domain: window.location.host });
        companyInfo.value = data || {};
    }

    onMounted(() => {
        getCompanyInfo();
    })

    return { companyInfo }
}